import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/ar';
import { AppSettings } from '../app.settings';
@Pipe({
  name: 'timeWithAdd'
})
export class TimeWithAddPipe implements PipeTransform {
  constructor(private settings: AppSettings) {}
  transform(value: number, args: string = 'hh:mm A', initTime: string = '2000-01-01 00:00'): string | number {
    let lang = 'en';
    if (this.settings.settings.rtl) lang = 'ar';
    if (value !== null && !isNaN(value))
      return moment(initTime)
        .locale(lang)
        .add(Math.abs(value), 'm')
        .format(args);
    return value;
  }
}
